// extracted by mini-css-extract-plugin
export var accordion = "textAccordion-module--accordion--b3080";
export var accordionWrapper = "textAccordion-module--accordionWrapper--4723e";